// testNavLock.js - decides whether header navigation is locked by a test.
// Only a STARTED test locks the nav. The pre-start details screen
// (testReadyToStart) must not lock it (AIT-253), even if a stale showQuiz is set.

export const isTestNavLocked = ({ showQuiz, quizMode, testReadyToStart } = {}) =>
  !testReadyToStart && Boolean(showQuiz) && quizMode === "test";
